import type { TEventWithDateRange } from 'App/irrigation-scheduler/utils/store/types'
import type moment from 'moment-timezone'

export const calculateDurationInWindow = (
  event: TEventWithDateRange,
  windowStart: moment.Moment,
  windowEnd: moment.Moment,
): number => {
  if (event.dateTo.isBefore(windowStart) || event.dateFrom.isAfter(windowEnd)) {
    return 0
  }

  const effectiveStart = event.dateFrom.isAfter(windowStart) ? event.dateFrom : windowStart
  const effectiveEnd = event.dateTo.isBefore(windowEnd) ? event.dateTo : windowEnd

  return Math.max(0, effectiveEnd.diff(effectiveStart)) / (1000 * 60)
}
